import React from 'react';
import styles from './index.less';

export default () => {
  return <div className={styles.krLabel}>KR</div>;
};
